export const environment = {
    production: true,
    apiRoot: "http://apis.saharamedicalcentre.com/",
    filePath: "Files/Images/",
    clientName: "Sahara Medical Centre"
};
